import React, { useState } from 'react';
import { useHomeCustomizationStore } from './store';
import AddNewItemButton from './AddNewItemButton';
import {
  SortableContainer,
  SortableElement,
  arrayMove,
} from 'react-sortable-hoc';
import LinkGroup from './LinkGroup';

const SortableList = SortableContainer(({ children }) => {
  return <div className="space-y-2">{children}</div>;
});

const SortableItem = SortableElement(({ children }) => {
  return <>{children}</>;
});
export default function EditableScene() {
  const { setHomeState, homeState, addNewGroup } = useHomeCustomizationStore();
  const [sorting, setSorting] = useState(false);
  return (
    <div className="w-full">
      <SortableList
        useDragHandle
        onSortEnd={({ oldIndex, newIndex }) => {
          setSorting(false);
          setHomeState(arrayMove(homeState, oldIndex, newIndex));
        }}
        onSortStart={() => setSorting(true)}
      >
        {homeState.map((group, index) => {
          return (
            <SortableItem index={index} key={group.id}>
              <LinkGroup group={group} />
            </SortableItem>
          );
        })}
      </SortableList>
      {!sorting && (
        <AddNewItemButton text="Add Group" onClick={() => addNewGroup()} />
      )}
    </div>
  );
}
